import baseService from './baseService';

export const getSkillsService = (organizationId = null, searchTerm = null) =>
  baseService.get(
    `${organizationId ? `/skills?organization_id=${organizationId}` : '/skills'}${
      searchTerm ? `?search_term=${searchTerm}` : ''
    }`
  );
